function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 11.1111C14.8012 11.1111 16.6667 9.24563 16.6667 6.94444C16.6667 4.64326 14.8012 2.77778 12.5 2.77778C10.1988 2.77778 8.33333 4.64326 8.33333 6.94444C8.33333 9.24563 10.1988 11.1111 12.5 11.1111ZM12.5 13.8889C8.66469 13.8889 5.55556 10.7798 5.55556 6.94444C5.55556 3.10913 8.66469 0 12.5 0C16.3353 0 19.4444 3.10913 19.4444 6.94444C19.4444 10.7798 16.3353 13.8889 12.5 13.8889ZM22.2222 25V20.8333C22.2222 19.2992 20.9786 18.0556 19.4444 18.0556H5.55556C4.02143 18.0556 2.77778 19.2992 2.77778 20.8333V25H0V20.8333C0 17.7651 2.48731 15.2778 5.55556 15.2778H19.4444C22.5127 15.2778 25 17.7651 25 20.8333V25H22.2222Z",
  fill: "#222222"
});

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2286b54b.svg";
export { ForwardRef as ReactComponent };